import React, { useEffect, useState } from 'react';
import apiClient from '../apiClient';
import { FaLock, FaUnlock, FaPlay, FaEye } from 'react-icons/fa';
import TakeAssessmentModal from '../components/assessment/TakeAssessmentModal';
// import DeployAssessmentModal from '../components/assessment/DeployAssessmentModal'; // Unused

const MyAssessments = () => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('take'); // 'take' or 'view'
  const [activeAssessment, setActiveAssessment] = useState(null);
  // const [activeQuestions, setActiveQuestions] = useState([]); // Unused
  const [userResult, setUserResult] = useState({});
  const [projects, setProjects] = useState([]);

  const fetchAssessments = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.get('/my-assessments');
      setAssessments(response.data.assessments || []);
    } catch (err) {
      setError('Failed to load assessments. Please try again.');
      console.error('Error fetching assessments:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchProjects() {
      try {
        const response = await apiClient.get('/projects/');
        setProjects(response.data);
      } catch (err) {
        console.error('Error fetching projects:', err);
      }
    }
    fetchProjects();
  }, []);

  const getProjectName = (projectId) => {
    const project = projects.find(p => p.id === projectId);
    return project ? project.name : projectId;
  }; 

  useEffect(() => {
    fetchAssessments();
  }, []);

  // Comment out unused fetchQuestions function
  // const fetchQuestions = async (assessmentType) => {
  //   const templatesRes = await apiClient.get('/assessment-templates');
  //   const template = (templatesRes.data.templates || []).find(t => t.name === assessmentType);
  //   if (!template) throw new Error('Template not found');
  //   const templateDetail = await apiClient.get(`/assessment-templates/${template.id}`);
  //   return templateDetail.data.questions || [];
  // };

  // Helper to fetch user result for an assessment
  const fetchUserResult = async (assessmentId) => {
    try {
      const resultResponse = await apiClient.get(`/assessments/${assessmentId}/results`);
      return resultResponse.data || {};
    } catch (err) {
      console.error('Error fetching user results:', err);
      return {};
    }
  };

  // Helper to submit answers
  const submitAnswers = async (assessmentId, answers) => {
    // PATCH or POST to /api/assessments/<id>/submit or similar (to be implemented in backend)
    await apiClient.post(`/assessments/${assessmentId}/submit`, { answers });
    fetchAssessments();
  };

  const handleLaunch = async (assessment) => {
    try {
      setError(null);
      setModalMode('take');
      setActiveAssessment(null);
      // Get all templates, find by name
      const templatesRes = await apiClient.get('/assessment-templates');
      const template = (templatesRes.data.templates || []).find(t => t.name === assessment.title);
      if (!template) throw new Error('Template not found');
      // Get questions for this template
      const templateDetail = await apiClient.get(`/assessment-templates/${template.id}`);
      const questions = templateDetail.data.questions || [];
      setActiveAssessment({ 
        ...assessment, 
        questions, 
        template: templateDetail.data,
        onSubmit: (answers) => submitAnswers(assessment.id, answers) 
      });
      setShowModal(true);
    } catch (err) {
      setError('Failed to load assessment questions.');
    }
  };

  // ... existing code ...
  const handleView = async (assessment) => {
    try {
      setError(null);
      setModalMode('view');
      setActiveAssessment(null);

      // Fetch the template for this assessment
      const templatesRes = await apiClient.get('/assessment-templates');
      const template = (templatesRes.data.templates || []).find(t => t.name === assessment.title);
      if (!template) throw new Error('Template not found');
      const templateDetail = await apiClient.get(`/assessment-templates/${template.id}`);
      const questions = templateDetail.data.questions || [];

      // Fetch the user's answers (now formatted with question text from backend)
      const userResult = await fetchUserResult(assessment.id);
      setUserResult(userResult);

      setActiveAssessment({ 
        ...assessment, 
        questions,
        template: templateDetail.data,
        onSubmit: () => {} 
      });
   
      // Delay opening the modal until after state updates
      setTimeout(() => setShowModal(true), 0);
    } catch (err) {
      setError('Failed to load assessment for viewing.');
      console.error('Error in handleView:', err);
    }
  };
// ... existing code ...

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="my-assessments-page">
      {/* <h2>My Assessments</h2> Removed redundant title */}
      {/* Placeholder for notification banner */}
      <table className="my-assessments-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Project</th>
            <th>Due Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {assessments.length === 0 ? (
            <tr><td colSpan={4}>No assessments assigned to you.</td></tr>
          ) : (
            assessments.map(a => {
              let status = a.locked ? 'Locked' : (a.status === 'taken' ? 'Taken' : 'Unlocked');
              let canLaunch = !a.locked && a.status !== 'taken';
              let canView = a.status === 'taken';
              return (
                <tr key={a.id}>
                  <td>{a.title}</td>
                  <td>{getProjectName(a.project_id)}</td>
                  <td>{a.due_time ? new Date(a.due_time).toLocaleString() : '-'}</td>
                  <td>
                    {status === 'Locked' && <FaLock title="Locked" />} 
                    {status === 'Unlocked' && <FaUnlock title="Unlocked" />} 
                    {status === 'Taken' && <FaEye title="Taken" />} 
                  </td>
                  <td>
                    {canLaunch ? (
                      <button className="launch-btn" onClick={() => handleLaunch(a)}><FaPlay /> Launch</button>
                    ) : canView ? (
                      <button className="view-btn" onClick={() => handleView(a)}><FaEye /> View</button>
                    ) : (
                      <span>-</span>
                    )}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
      <TakeAssessmentModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        assessment={activeAssessment}
        mode={modalMode}
        userResult={userResult}
      />
    </div>
  );
};

export default MyAssessments; 